import {
    SET_REQUISITION_DROP_DOWN
} from "./RequisitionDropDownType";

const initialState = {
    requisitionDropDown: {}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_REQUISITION_DROP_DOWN:
            return {
                ...state,
                requisitionDropDown: action.requisitionDropDown,
            };
        default:
            return state;
    }
};

export default reducer;
